module.exports = __webpack_public_path__ + "static/media/selectHover.0e359cf3.svg";